import Component from '@bythepixel/component-loader';

const selectors = {
  inputActiveClass: 'input-group__input--active',
  labelActiveClass: 'input-group__label--active',
};

export default class InputGroup extends Component {
  static loaderPriority = 'in-view';
  static selector = '[data-comp-input-group]';

  constructor(containerEl) {
    super(containerEl);
    this.input = this.$container.querySelector('[data-input]');
    this.label = this.$container.querySelector('[data-label]');
    if (this.$container) {
      this.init();
    }
  }

  init() {
    if (this.input.value) {
      this.label.classList.add(selectors.labelActiveClass);
    }
    this.addInputListeners();
  }

  addInputListeners() {
    this.input.addEventListener('focus', () => {
      this.input.classList.add(selectors.inputActiveClass);
      this.label.classList.add(selectors.labelActiveClass);
    });

    this.input.addEventListener('focusout', () => {
      this.input.classList.remove(selectors.inputActiveClass);
      if (!this.input.value) {
        this.label.classList.remove(selectors.labelActiveClass);
      }
    });
  }
}
